export default {
    
    setSelectedPrestIds: (state, obj) => {
        Object.entries(obj).forEach(([key, value]) => {
            //selectedPrestIdsObj should be object with keys as refs and values as number of such prestations
            const newObj = {...state.selectedPrestIds}
            if (!value || value === 0) {
                delete newObj[key]
                state.selectedPrestIds = newObj
            } else {
                newObj[key] = value
                state.selectedPrestIds = newObj
            }
        })
        if (Object.keys(state.selectedPrestIds).length>0) {
            window.sessionStorage.setItem(`selectedPrestIds-${state.liheData.id}`, JSON.stringify(state.selectedPrestIds))
        } else {
            window.sessionStorage.removeItem(`selectedPrestIds-${state.liheData.id}`)
        }
    },

    clearSelectedPrestIds: (state) => {
        state.selectedPrestIds = {}
        window.sessionStorage.removeItem(`selectedPrestIds-${state.liheData.id}`)
    },

    clearSelectedSpecialTypes: (state) => {
        state.selectedFlexTypes.flex = 0
        state.selectedFlexTypes.nonflex = 0
        state.skiPassDays.days6 = 0
        state.skiPassDays.days7 = 0
        state.skiPassDays.days8 = 0
    },

    clearSelectedPrestIdFusions: (state) => {
        state.selectedPrestIdsFusion = new Set()
    },
    
    setSelectDropdownOpen_prestId: (state, {id, select_location}) => { // "id" is prestation id whose select dropdown is open
        state.selectDropdownOpen_prestId = id
        state.selectDropdownOpen_location = select_location
    },
    
    setFlexTypeAmount(state, {flexType, increaseAmount = true}) {
        if(increaseAmount) {
            state.selectedFlexTypes[flexType] += 1
            return
        }
        state.selectedFlexTypes[flexType] -= 1
    },

    setSkiPassDays(state, {daysAmount, increaseAmount = true}) {
        if(increaseAmount) {
            state.skiPassDays[daysAmount] += 1
            return
        }
        state.skiPassDays[daysAmount] -= 1
    },

    addSelectedPrestIdFusion(state, fusionId) {
        state.selectedPrestIdsFusion.add(fusionId)
    },

    removeSelectedPrestIdFusion(state, fusionId) {
        state.selectedPrestIdsFusion.delete(fusionId)
    },
}